import { Component } from 'react';
import { concat, from } from 'rxjs';

import { IOC_TYPES } from '../../../context/ioc.types';
import { lazyInject } from '../../../context/module';
import { ScriptLoadService } from '../../../services/script-load.service';
import { untilDestroyed } from '../../../utils/until-destroyed';
import styles from './product-page.component.module.scss';

export default class ProductPageComponent extends Component {

    @lazyInject(IOC_TYPES.ScriptLoadService) private scriptLoader: ScriptLoadService;

    constructor(props) {
        super(props);
    }

    componentDidMount() {
        concat(
            from(this.scriptLoader.loadAllScriptsIfNotLoaded(true)),
            from(this.scriptLoader.loadStripe()),
            from(this.scriptLoader.loadPayPal()),
        ).pipe(
            untilDestroyed(this),
        ).subscribe({
            next: () => {
                // skip
            }
        });
        // TODO Preact fix
        // this.renderer.addClass(this.document.body, 'product-page');
    }

    componentWillUnmount() {
        // TODO Preact fix
        // this.renderer.removeClass(this.document.body, 'product-page');
    }

    render() {
        return <div className="container-fluid">
            <div className={`row ${styles['product-page']}`}>
                <div className={`col-sm-12 text-center ${styles['title']}`}>
                    <span>X</span>
                </div>
                <div className={`col-sm-12 ${styles['sub-title']}`}>
                    <h1 className={`text-center display-4 ${styles['sub-title-text']}`}>
                        XConvert Unlimited
                    </h1>
                </div>
                <div className="col-sm-12">
                    <p className={`text-center ${styles['sub-heading']}`}>
                        Fast upload, higher compression, priority processing, and much more.
                    </p>
                </div>
                <div className="col-sm-12" >
                    <div className="row" style={{ minHeight: '50vh' }} >
                        <div className="col-sm-12 col-md-2 col-lg-2" >

                        </div >
                        <div className={`col-sm-12 col-md-8 col-lg-8 ${styles['display-image']}`}>
                            <img className={`mt-5 ${styles['frame']}`} src="/img/xconvert/desktop/windows/screen2.png" />
                        </div>
                        <div className="col-sm-12 col-md-2 col-lg-2" >

                        </div >
                    </div >

                    <div className="col-sm-12 mt-5" >
                        <div className="text-center" >
                            <img src="/img/xconvert/desktop/windows/cpu.svg" className={`${styles['speedmeter']}`} />
                            <h1 className={`display-4 ${styles['sub-title-text']}`}>
                                A Powerful Online Solution
                            </h1>
                            <div className={`text-center mb-2 ${styles['sub-heading']}`}>
                                The best tool to convert, compress, merge and split document and media files.</div>
                        </div >
                    </div >

                    <div className="row" >
                        <div className="col-sm-1 col-md-2" ></div >
                        <div className="col-sm-10 col-md-8" >
                            <div className="row" >
                                <div className="col-sm-12 col-md-6" >
                                    <div className="text-center" >
                                        <img src="/img/xconvert/desktop/windows/media-encoder.svg" className={`${styles['feaure-image']}`} />
                                        <h4 className={`${styles['feature-title']}`}>
                                            Higher Compression
                                        </h4>
                                    </div >
                                    <div className={`${styles['feature-text']}`}>
                                        Advanced encoders such as HEVC and VP9 for videos, JPEG encoding for TIFF and Prepress PDF
                                        compressors are are activated for all paid users. This allows higher compression while
                                        keeping the quality intact. Some encoders like HEVC for videos, allow 50% file size
                                        reduction for the same quality offered by H.264.
                                    </div>
                                </div >
                                <div className="col-sm-12 col-md-6" >
                                    <div className="text-center" >
                                        <img className={`${styles['feaure-image']}`} src="/img/xconvert/desktop/windows/infinite.svg" />
                                        <h4 className={`${styles['feaure-title']}`}>
                                            More Storage and Time
                                        </h4>
                                    </div >
                                    <div className={`${styles['feature-text']}`}>
                                        As a paid user, you will get more process time per each process.
                                        Your requests are processed immediately with escalated <a
                                            href="https://en.wikipedia.org/wiki/Nice_(Unix)">
                                            priority</a>. With XConvert online app,
                                        Basic users can upload files larger as large as 1 GB and our super supporters, Pro users,
                                        get 4 GB file size limit.
                                    </div>
                                </div >
                                <div className="col-sm-12 col-md-6" >
                                    <div className="text-center" >
                                        <img className={`${styles['feaure-image']}`} src="/img/xconvert/desktop/windows/padlock.svg" />
                                        <h4 className={`${styles['feaure-title']}`}>
                                            Priority Processing
                                        </h4>
                                    </div >
                                    <div className={`${styles['feature-text']}`}>
                                        Paid subscribers are given full <a href="https://en.wikipedia.org/wiki/Nice_(Unix)">
                                            priority</a> over regular users. With more CPU time, paid users can get their work done
                                        faster.
                                    </div>
                                </div >
                                <div className="col-sm-12 col-md-6" >
                                    <div className="text-center" >
                                        <img className={`${styles['feaure-image']}`} src="/img/xconvert/desktop/windows/speedometer.svg" />
                                        <h4 className={`${styles['feaure-title']}`}>
                                            Faster File Uploading
                                        </h4>
                                    </div >
                                    <div className={`${styles['feature-text']}`}>
                                        Patron members can upload directly through massive CDN provided
                                        <a href="https://cloud.google.com/storage/">Google Cloud Storage</a>. This
                                        gives the fastest upload available.
                                    </div>
                                </div >
                            </div >
                        </div >
                        <div className="col-sm-1 col-md-2" ></div >
                    </div >

                    <div className={`${styles['packages']} mt-3`}>
                        <div className={styles['package-container']}>
                            <div className={`${styles['package']} ${styles['left-package']}`}>
                                <div>&nbsp;</div>
                                <div className="text-center mt-3 mb-5">
                                    <h4>Basic</h4>
                                </div>
                                <div className="text-center mb-3" >
                                    <a className={`x-btn x-btn-gray x-btn-gray-outline p-1`} href="/product/backer_monthly"
                                    >
                                        $4.99 USD / month
                                    </a>
                                </div >
                                <div className="text-center mb-1" > Or prepay annually(save 16 %):</div >
                                <div className="text-center mb-3" >
                                    <a className={`x-btn x-btn-gray x-btn-gray-outline p-1`} href="/product/backer_yearly"
                                    >
                                        $49.99 USD / year
                                    </a>
                                    <br />
                                    <small>(USD 4.17 / month billed annually)</small>
                                </div >
                                <div>
                                    <ul className="text-left">
                                        <li className={`${styles['check']}`}>1 GB file size</li>
                                        <li className={`${styles['check']}`}>4 hr/task process time</li>
                                        <li className={`${styles['check']}`}>10 Concurrent non-video tasks</li>
                                        <li className={`${styles['check']}`}>4 Concurrent video tasks</li>
                                        <li className={`${styles['check']}`}>No ads</li>
                                        <li className={`${styles['check']}`}>Advanced encoders</li>
                                    </ul>
                                </div >
                            </div >
                        </div>

                        <div className={styles['package-container']}>
                            <div className={`${styles['package']} ${styles['right-package']}`}>
                                <div className="font-weight-bold text-center">Recommended</div>
                                <div className="text-center mt-3 mb-5" >
                                    <h4>Pro</h4>
                                </div >
                                <div className="text-center mb-3" >
                                    <a className={`x-btn x-btn-gray x-btn-gray-outline p-1`} href="/product/patron_monthly"
                                    >
                                        $9.99 USD / month
                                    </a>
                                </div >
                                <div className="text-center mb-1" > Or prepay annually(save 16.5 %):</div >
                                <div className="text-center  mb-3" >
                                    <a className={`x-btn x-btn-primary p-1 ${styles['recommended']}`} href="/product/patron_yearly"
                                    >
                                        $99.99 USD / year
                                    </a>
                                    <br />
                                    <small>(USD 8.33 / month billed annually)</small>
                                </div >
                                <div>
                                    <ul className="text-left">
                                        <li className={`${styles['check']}`}>4 GB file size</li>
                                        <li className={`${styles['check']}`}>Faster file upload*</li>
                                        <li className={`${styles['check']}`}>4 hr/task process time</li>
                                        <li className={`${styles['check']}`}>25 Concurrent non-video tasks</li>
                                        <li className={`${styles['check']}`}>8 Concurrent video tasks</li>
                                        <li className={`${styles['check']}`}>No ads</li>
                                        <li className={`${styles['check']}`}>High compression encoders</li>
                                    </ul>
                                    <div className="mt-1" >
                                        <small>* <a href="https://cloud.google.com/storage/">GCP low latency object
                                            storage</a> used for file smaller then 100 MB.</small>
                                    </div >
                                </div >
                            </div >
                        </div>
                    </div>

                    <div className="row mt-5" >
                        <div className="col-sm-12 col-md-6 mt-4" >
                            <div className="row" >
                                <div className="col-1 col-sm-2 col-md-1" >&nbsp;</div >
                                <div className="col-10 col-sm-8 col-md-11" >
                                </div >
                                <div className="col-1 col-sm-2 col-md-1 d-md-none" >&nbsp;</div >
                            </div >
                        </div >
                        <div className="col-sm-12 col-md-6 mt-4" >
                            <div className="row" >
                                <div className="col-1 col-sm-2 col-md-1 d-md-none" >&nbsp;</div >
                                <div className="col-10 col-sm-8 col-md-11" >

                                    <div className="col-1 col-sm-2 col-md-1" >&nbsp;</div >
                                </div >
                            </div >
                        </div >
                    </div >

                    <div className="col-sm-12 mt-5" >
                        <div className="text-center" >
                            <img className={`speedmeter ${styles['speedmeter']}`} src="/img/xconvert/desktop/windows/question.svg" />
                            <h2>
                                Frequently Asked Questions
                            </h2>
                            <small>&nbsp;</small>
                        </div >
                    </div >

                    <div className="row" >
                        <div className="col-sm-1 col-md-2" ></div >
                        <div className="col-sm-10 col-md-4" >
                            <h5 className={`${styles['qa-section']}`}>General & Privacy</h5>
                            <h6 className={`mt-2 ${styles['qa-question']}`}>Can I use this on multiple devices?</h6>
                            <div>We allow users to connect to backend from upto 3 devices at once.</div>
                            <h6 className={`mt-2 ${styles['qa-question']}`}>Why do you need my E-mail?</h6>
                            <div>For verification purpose, we require a valid e-mail address. You will be using your e-mail to log
                                into the system. Plus, this is especially important if you want to cancel your subscription.</div>
                            <h6 className={`mt-2 ${styles['qa-question']}`}>What kind of support do you offer?</h6>
                            <div>XConvert is a SaaS product. You will recieve all updates and bug fixes free of charge.
                                Paid users will able to use any new features we adds to the XConvert.
                            </div>
                            <h6 className={`mt-2 ${styles['qa-question']}`}>Who can access my files?</h6>
                            <div>Your connection to our backend servers are encrypted with TLSv1.2 and your files are automatically
                                deleted every 6 hours.
                            </div>
                        </div >
                        <div className="col-sm-10 col-md-4" >
                            <h5 className={`${styles['qa-section']}`}>Payment & Billing</h5>
                            <h6 className={`mt-2 ${styles['qa-question']}`}>What are my payment options?</h6>
                            <div>We accept PayPal, Visa, MasterCard, American Express, Diners Club, JCB, Discover, etc...</div>

                            <h6 className={`mt-2 ${styles['qa-question']}`}>What’s your cancellation and refund policy?</h6>
                            <div>You can login to XConvert user portal and cancel your subscription at anytime.
                                We don’t offer refunds, however, you may use the program after cancellation until the end of billing
                                cycle.</div>
                            <h6 className={`mt-2 ${styles['qa-question']}`}>Do you offer special pricing to nonprofit organizations and educational
                                institutions?</h6>
                            Yes, contact us at support@xconvert.com to learn about our special pricing structure.
                        </div >
                        <div className="col-sm-1 col-md-2" ></div >
                    </div >
                </div >
            </div >
        </div>
    }
}
